import * as React from "react";
import get from "lodash/get";

import "./LedgerTotal.css";
import { ComponentBase, ComponentBaseProps } from "../ComponentBase";
import { getLedgerHead, getRewardRequestStatus } from "../../reducers/methods";
import { RequestStatus } from "../../types/requestStatus";
import { currencySymbols } from "../../utils/currencies";
import { formatUserFacingNumber } from "../../utils/number";

export interface LedgerTotalProps extends ComponentBaseProps {
  action: string;
  center: string;
  classNames: string;
  label: string;
  ledgerHead: ReturnType<typeof getLedgerHead>;
  onClick: () => void;
  requestStatus: ReturnType<typeof getRewardRequestStatus>;
  currency?: string;
  style: { [styleProp: string]: string };
}

function formatBalance(
  currencySymbol: any,
  ledgerHead: ReturnType<typeof getLedgerHead>,
  isEditing: boolean
) {
  const balance = formatUserFacingNumber(
    Number(get(ledgerHead, "balance", isEditing ? 50 : 0))
  );

  return `${currencySymbol}${balance}`;
}

// tslint:disable-next-line:no-any
export class LedgerTotal extends ComponentBase<LedgerTotalProps> {
  render() {
    const {
      classNames,
      data,
      label = "ledger_total",
      isEditing,
      ledgerHead,
      requestStatus,
      currency = "USD",
    } = this.props;
    const isCustomerAuthenticated = get(data, "customer.authenticated", false);
    const getLedgerRequestStatus = get(
      requestStatus,
      "getLedger"
    ) as RequestStatus;
    if (!isCustomerAuthenticated && !isEditing) {
      return null;
    }

    const currencySymbol: string =
      currency === "loyalty" ? "" : get(currencySymbols, currency, currency);

    return (
      <div
        id={this.props.configName}
        onDragStart={this.onDragStart}
        onAnimationEnd={this.resetAnimation}
        style={this.props.style}
        className={`LedgerTotal-container  ${classNames || ""} ${
          this.state.animationClass
        }`}
        aria-label={label}
        ref={(component) => (this.component = component)}
      >
        {getLedgerRequestStatus === "REQUESTING" && <span>...</span>}
        {(getLedgerRequestStatus === "SUCCESS" || isEditing) &&
          formatBalance(currencySymbol, ledgerHead, isEditing)}
      </div>
    );
  }
}
